import m from "../../geodata/es2015/kyrgyzstanLow";
window.am4geodata_kyrgyzstanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/kyrgyzstanLow.js
// module id = null
// module chunks = 